module.exports = __webpack_public_path__ + "static/media/人脸识别双足机器人.3c07526f.png";